import React, { useContext, useState } from 'react';

import LinearProgress from '@mui/material/LinearProgress';

import useWindowDimensions from '../../Hooks/useWindowDimensions';
import AssessmentQuestionContext from '../../Store/AssessmentQuestionContext';
import { In } from 'framer-motion';

const ProgressBar = props => {

  // console.log("ProgressBar props", props);

  const { windowWidth } = useWindowDimensions();
  const assmentCtx = useContext(AssessmentQuestionContext);
  const threeWaytieBreakersPageIdArray = [955, 956, 957, 958]
  const twoWaytieBreakersPageIdArray = [949, 959, 966, 967, 968, 969, 970]
  const twoWaytieBreakersPageIdArrayRound2 = [985, 986, 987, 989, 990, 978]

  const threeWaytieBreakersPageIdArrayLeadership = [960, 961, 962, 963]
  const twoWaytieBreakersPageIdArrayLeadership = [965, 964, 971, 964, 972, 973, 974, 975]
  const twoWaytieBreakersPageIdArrayRound2Leadership = [984, 996, 997, 998, 999, 1000, 1001]

  const allTiebreakerPageIds = [
    955, 956, 957, 958, 949, 959, 966, 967, 968, 969, 970,
    985, 986, 987, 989, 990, 978, 960, 961, 962, 963, 965,
    964, 971, 972, 973, 974, 975, 984, 996, 997, 998, 999, 1000, 1001
  ];

  const roundTwoTiebreakers = [985, 986, 987, 989, 990, 978, 984, 996, 997, 998, 999, 1000, 1001]
  // console.log("allTiebreakersPageId", allTiebreakerPageIds)
  const isTieBreaker = allTiebreakerPageIds.includes(parseInt(props?.pageId));
  const roundTwoTies = roundTwoTiebreakers.includes(parseInt(props?.pageId));

  const isStarter = twoWaytieBreakersPageIdArray?.includes(parseInt(props?.pageId)) || threeWaytieBreakersPageIdArray?.includes(parseInt(props?.pageId)) || twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(props?.pageId)) || props?.pageId == "866" || props?.pageId == "953";
  const isLeader = twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(props?.pageId)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(props?.pageId)) || twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(props?.pageId)) || props?.pageId == "954" || props?.pageId == "947";
  const isMindSet = props?.pageId === "948" ? true : false;

  let allQuestions = assmentCtx?.allQuestions;
  let activeColor = '#578494';
  let passiveColor = '#578494';
  let sections = [];
  let numOfQuestions = props?.count + props?.tiebreakerQuestionCount || props?.count;
  const currentProgress = props?.currentProgress;
  const questionsPerSection = props?.questionsPerSection.map((q, index) =>
    index === props?.currentSectionIndex && props?.tiebreakerQuestionCount
      ? q + props?.tiebreakerQuestionCount
      : q
  );
  const getPreviousCompletedQuestions = props?.getPreviousCompletedQuestions;
  let totalQues = 0;
  questionsPerSection.forEach(q => totalQues += q);
  const maxProgressPerSec = questionsPerSection?.map((item, idx) => questionsPerSection.slice(0, idx + 1).reduce((a, b) => a + b));
  // min progress needed in first section is always 0 
  const minProgressPerSec = [0, ...maxProgressPerSec];
  // console.log("minProgress", minProgressPerSec);

  props?.sections?.forEach((section, idx) => {
    sections.push({
      name: section.section,
      style: { color: passiveColor, fontWeight: '400' },
      questions: idx === props?.currentSectionIndex ? props?.questionsPerSection[idx] + props?.tiebreakerQuestionCount : props?.questionsPerSection[idx],
      progress: 0,
      minProgress: minProgressPerSec[idx],
      maxProgress: maxProgressPerSec[idx]
    });
  });

  // console.log("sections", sections);

  let progressWidth = (100 / sections.length) + '%';
  if (window.innerWidth < 650) {
    progressWidth = '100%';
  }
  const validNumber = (num) => (typeof num === 'number' && !isNaN(num) ? num : 0);


  sections.forEach((sec, idx) => {
    const totalProgress = validNumber(currentProgress) + validNumber(getPreviousCompletedQuestions());
    if ((isMindSet && sec?.name === "Mindset") || (isLeader && sec?.name === "Leadership") || (isStarter && sec?.name === "Starter")) {
      sec.progress = ((totalProgress - sec.minProgress + 1) / sec.questions) * 100;
      sec.style = { color: '#578494', fontWeight: '700', fontSize: '18px' };
    }
    else if (totalProgress >= sec.maxProgress) {
      sec.progress = 100;
    }
    else {
      sec.progress = -1;
      sec.style = { color: '#578494', fontWeight: '400', fontSize: '18px' };
    }
  });

  console.log('props.questions', props.questions)

  const getDisplayProgress = () => {

    // console.log("allQuestions assmentCtx",assmentCtx?.allQuestions)

    const pageIdArray = assmentCtx?.allQuestions?.flatMap((el) => el?.pageId)
    const allQuestions = assmentCtx?.allQuestions?.flatMap((el) => {
      if (el?.pageId == "866" || el?.pageId == "953" || el?.pageId == "947" || el?.pageId == "954" || el?.pageId == "948") {
        return el?.data
      }
      return []
    });

    const getUnVisitedPagidQuestions = () => {
      if (!pageIdArray?.includes("953")) {
        return 72; // 953 = 20
      }
      else if (!pageIdArray?.includes("947")) {
        return 72 - 20; // 947 = 20
      }
      else if (!pageIdArray?.includes("954")) {
        return 72 - 20 - 20; // 954 = 20 & 947 = 20
      }
      else if (!pageIdArray?.includes("948")) {
        return 12;
      }

      return 0;
    }

    let totalQuestions = 92
    let currentQIndex = 0;

    for (let i in allQuestions) {
      if (allQuestions[i]?.id == props?.currentQuestion?.id) currentQIndex = i;
    }

    if (twoWaytieBreakersPageIdArray?.includes(parseInt(props?.pageId)) || threeWaytieBreakersPageIdArray?.includes(parseInt(props?.pageId))) {
      currentQIndex = 19;
    }
    else if (twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(props?.pageId))) {
      currentQIndex = 38;
    }
    else if (twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(props?.pageId)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(props?.pageId))) {
      currentQIndex = 59;
    }
    else if (twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(props?.pageId))) {
      currentQIndex = 78;
    }

    let displayProgress = ((currentQIndex / totalQuestions) * 100) + 1;
    console.log("currentSecTotal(totalQuestions)-currentQIndex-allQuestions-displayProgress", totalQuestions, currentQIndex, allQuestions, displayProgress)

    return displayProgress;
  }

  const displayProgress = getDisplayProgress();

  const getMaxProgressSectionWise = (section_name) => {
    console.log("section_name-isStarter", section_name, isStarter, isLeader)
    if (isStarter && section_name == "Starter") return true;
    if (isLeader && section_name == "Leadership") return true;
    if (props?.pageId == "948" && section_name == "Mindset") return true;
    else return false
  }

  const getProgress = (section_name) => {

    const allQuestions = assmentCtx?.allQuestions?.flatMap((el) => {
      if (el?.pageId == "866" || el?.pageId == "953" || el?.pageId == "947" || el?.pageId == "954" || el?.pageId == "948") {
        return el?.data
      }
      return []
    });

    const pageIdArray = assmentCtx?.allQuestions?.flatMap((el) => el?.pageId)

    // finding the index of the last question here
    // and then that index will be used to determine the size of the
    // particular section

    const currentSectionQuestions = allQuestions?.filter((el) => getSectionWiseQuestion(el.pageId))
    let currentQidx = 0;

    for (let i in currentSectionQuestions) {
      if (currentSectionQuestions[i]?.id == props?.currentQuestion?.id) currentQidx = i;
    }

    let currentSecTotal = 0;

    if (props?.pageId == "866") {
      currentSecTotal = currentSectionQuestions?.length + 20;
    }
    else if (twoWaytieBreakersPageIdArray?.includes(parseInt(props?.pageId)) || threeWaytieBreakersPageIdArray?.includes(parseInt(props?.pageId))) {
      currentQidx = 19;
      currentSecTotal = currentSectionQuestions?.length + 20;
    }
    else if (twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(props?.pageId))) {
      currentQidx = 38;
      currentSecTotal = currentSectionQuestions?.length;
    }
    else if (props?.pageId == "947") {
      currentSecTotal = currentSectionQuestions?.length + 20;
    }
    else if (twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(props?.pageId)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(props?.pageId))) {
      currentQidx = 19;
      currentSecTotal = currentSectionQuestions?.length + 20;
    }
    else if (twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(props?.pageId))) {
      currentQidx = 78;
      currentSecTotal = currentSectionQuestions?.length;
    }
    else if ( props?.pageId == "948" ) {
      currentQidx = 40;
      currentSecTotal = currentSectionQuestions?.length;
    }
    else {
      currentSecTotal = currentSectionQuestions?.length
    }

    // else if (twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(props?.pageId)) || twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(props?.pageId))) {
    //   currentSecTotal = currentSectionQuestions?.length;
    // }
    // else if (twoWaytieBreakersPageIdArray?.includes(parseInt(props?.pageId)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(props?.pageId)) || threeWaytieBreakersPageIdArray?.includes(parseInt(props?.pageId)) || twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(props?.pageId))) {
    //   currentSecTotal = currentSectionQuestions?.length + 20;
    // }
    // else if (props?.pageId == "947") {
    //   currentSecTotal = currentSectionQuestions?.length + 20;
    // }


    let progress;
    progress = ((currentQidx / currentSecTotal) * 100);

    console.log("currentSectionQuestions-allQuestions-currentQidx-progress-pageIdArray", currentSectionQuestions, allQuestions, currentQidx, progress, pageIdArray)



    // ANIMATION CONTROL LOGIC STARTS HERE

    if (props?.back && !props.isPauseScreen) {
      if (section_name == "Starter" && ( props?.pageId == '866' || twoWaytieBreakersPageIdArray?.includes(parseInt(props?.pageId)) || threeWaytieBreakersPageIdArray?.includes(parseInt(props?.pageId)))) {
        return 50;
      }
      else if (section_name == "Starter" && ( props?.pageId == '953' || twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(props?.pageId)))) {
        return 100;
      }
      else if (section_name == "Leadership" && twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(props?.pageId))) {
        if ( section_name == "Starter") return 100;
        else if ( section_name == "Leadership") return 100;
      }
      else if (section_name == "Leadership" && props?.pageId == "954" ) {
        if ( section_name == "Starter") return 100;
        else if ( section_name == "Leadership") return 100;
      }
      else if (section_name == "Leadership" && twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(props?.pageId)) ) {
        if ( section_name == "Starter") return 100;
        else if ( section_name == "Leadership") return 100;
      }
    }

    if (props?.next && !props.isPauseScreen) {
      if (section_name == "Starter" && (twoWaytieBreakersPageIdArray?.includes(parseInt(props?.pageId)) || threeWaytieBreakersPageIdArray?.includes(parseInt(props?.pageId)))) {
        return 50;
      }
      else if (section_name == "Starter" && ( props?.pageId == "953")) {
        if ( props?.activeStep == 18 ) {
          return 100;
        }
        return 50;
      }
      else if (section_name == "Starter" && twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(props?.pageId))) {
        return 100;
      }
      else if (section_name == "Leadership" && ( props?.pageId == "954")) {
        if ( section_name == "Starter") return 100;
        else if ( section_name == "Leadership") {
          if ( props?.activeStep == 18 ) {
            return 95;
          }
          else {
            return 50;
          }
        }
      }
    }

    // ANIMATION CONTROL LOGIC ENDS HERE

    if (isStarter) {
      if (section_name == "Starter") return progress;
      else return 0;
    }
    else if (isLeader) {
      if (section_name == "Starter") return 100;
      else if (section_name == "Leadership") return progress;
      else return 0;
    }
    else if (isMindSet) {
      let progress = ((props?.activeStep / props?.questions?.length) * 100);
      if (props?.activeStep == 11) progress = 100;
      // console.log("activestep-questions-progress",props?.activeStep, props?.questions?.length,progress)
      if (section_name == "Starter") return 100;
      else if (section_name == "Leadership") return 100;
      else return progress;
    }
  }

  const getSectionWiseQuestion = (page_id) => {
    if (isStarter && (twoWaytieBreakersPageIdArray?.includes(parseInt(page_id)) || threeWaytieBreakersPageIdArray?.includes(parseInt(page_id)) || twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(page_id)) || page_id == 866 || page_id == 953)) {
      return true;
    }
    if (twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(page_id)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(page_id)) || twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(page_id)) || page_id == 947 || page_id == 954) {
      return true;
    }
    else if (page_id == "948") {
      return true;
    }
    else {
      return false
    }
  }

  const getMarginTop = (section_name) => {
    // if (isTieBreaker) return false;
    if (isStarter) {
      if (section_name == "Leadership") return false;
      if (section_name == "Mindset") return false;
      else return true;
    }
    else if (isLeader) {
      if (section_name == "Starter") return false;
      else if (section_name == "Mindset") return false;
      else return true;
    }
    else if (props?.pageId == "948") {
      if (section_name == "Starter") return false;
      else if (section_name == "Leadership") return false;
      else return true;
    }
  }

  return (
    <div>
      <div className="progress-bar">
        {sections.map((sec, index) => {
          let progress = getProgress(sec?.name);
          // props?.setProgressBack(false)
          console.log("progress,props?.pageId-props.back-,props.next,props?.activeStep", progress, props?.pageId, props.back, props.next, props?.activeStep)
          if (progress > 100) progress = 100;
          return (
            <div className="bar-section" style={{ width: progressWidth, marginTop: getMarginTop(sec?.name) ? "0px" : "35px", }} key={index}>
              {/* {(sec.progress > 0 && sec.progress <= 100)?
                <img style={{marginLeft: (sec.progress - 9) + '%', transition: '1s'}}decoding="async" height="30" src="https://md1.bleat.church/wp-content/uploads/2021/05/paper-boat.png" className="attachment-full size-full" alt="" loading="lazy" />
                : <img style={{marginLeft: (sec.progress - 9) + '%', opacity: 0}}decoding="async" height="30" src="https://md1.bleat.church/wp-content/uploads/2021/05/paper-boat.png" className="attachment-full size-full" alt="" loading="lazy" />
              } */}
              {console.log("sec-progress", sec, progress)}
              {
                getMaxProgressSectionWise(sec?.name) && (
                  // !isTieBreaker && (
                  <p className="progress-percent-text" style={{ marginLeft: `calc(${progress}% - ${roundTwoTies ? '1.5ch' : '0.5ch'})`, color: activeColor, }} >
                    {`${Math.round(displayProgress)}%`}
                  </p>
                  // )
                )
              }
              <div className="bar"><LinearProgress className="custom-bar" variant="determinate" value={progress} /></div>
              <div className="section-title" style={sec.style}>{sec.name === "Starter" ? "STARTER/FLOW" : sec.name.toUpperCase()}</div>
            </div>
          )
        })}
      </div>
    </div>
  );
}
export default ProgressBar;
